/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for anypurpose without the express written permission of Honeywell. */
import React from "react";
import axios from "axios";

/**
 *
 * axios instace to reuse
 */
const oidcDefault: any = sessionStorage.getItem("oidc.default");
const accessToken =
  oidcDefault &&
  JSON.parse(oidcDefault)["tokens"] &&
  JSON.parse(oidcDefault)["tokens"]["accessToken"];

const instance = axios.create({
  headers: {
    Authorization: "Bearer " + accessToken,
    //   baseURL : "",
  },
  // .. other options
});

export default instance;
